import { MdClose } from 'react-icons/md'

import './pageaside.css'

const PageAside = ({title, closePage}) => {

      return (
            <div className="page_aside">
                  <div className="page_aside__button">
                        <button onClick={closePage}><MdClose /></button>
                        <span>Close</span>
                  </div>
                  <div className="page_aside__title">
                        <h1>{title}</h1>
                  </div>
            </div>
      )
}

export default PageAside
